const allCharacters = '^([a-zA-Z0-9._*+%\\-?^${}()|[\\]])';
const numbers = '([0-9])';

export const emailRegex = /^[a-zA-Z0-9._%+\-&,´'\s]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;

export const lengthValidation = (min, max) =>
  new RegExp(`${allCharacters}{${min},${max}}$`);

export const numberLengthValidation = (min, max) =>
  new RegExp(`${numbers}{${min},${max}}$`);

export const numberValidation = /^\d+$/;

export const phoneNumberValidation = /^\d{10}$/;
